import HTTPClient from 'core/services/HTTPClient'
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper'

export function createBulkUsers(options) {
    return async (): Promise<any> =>
      HTTPClient.POST(
        options.type === 'service' ?  HTTPUrlHelper.uploadClientAuthCertServiceUserAPI(options.id) : HTTPUrlHelper.getUploadCertificate(options.id),
        options.data,
        options.config
      )
  } 

